// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__31-sV","list":"PatternAutocomplete_list__cJfpT"};